<template>
    <div class="info">
        <b-container  class="infotable">
            <b-row v-for="(text, value) in info" :key="value" style="margin-bottom: 8%">
                <b-col v-if="icon" xl="3" class="icons">
                     <i :class="text.icon"></i>
                </b-col>
                <b-col v-else xl="3" class="value">
                    {{value}}
                </b-col>
                <b-col v-if="icon" xl="9" class="text2">
                    {{text.text}}
                </b-col>
                <b-col v-else xl="9" class="text">
                    {{text.text}}
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'Info',
    props: {
        icon: Boolean
    },
    data() {
        return {
            info: {
                Phone: {
                    icon: "fas fa-mobile-alt fa-3x",
                    text: '516-652-2351'
                },
                Email: {
                    icon: "fas fa-envelope-open-text fa-3x",
                    text: 'davidsen2993@gmail.com'
                },
                Location: {
                    icon: "fas fa-map-marker-alt fa-3x",
                    text: 'New York, NY'
                }
            }
        }
    }
}
</script>

<style scoped>
.infotable {
    padding: 0 10px;
    text-align: left;
}

.text2 {
    margin: auto;
}

.value {
     font-weight: bold;
     font-size: 11pt;
}

.text {
    color: #717171;
    font-size: 11pt;
}
</style>